import React from 'react';
import DefaultLayout from '../../../layouts/default';
import { TrainingRecordFormProvider } from '../context/TrainingRecordFormContext';
import TrainingRecordForm from '../components/TrainingRecordForm';
export default function AddTrainingRecord() { return <DefaultLayout><TrainingRecordFormProvider><TrainingRecordForm /></TrainingRecordFormProvider></DefaultLayout>; }
